import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./ProMoreQueries.module.css";
import {
  Avatar,
  Button,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle 
} from "@mui/material";

import Typography from "@mui/joy/Typography";
import { toast } from "react-toastify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


import { useUtil } from "../../../contexts/UtilContext.jsx";

function ProMoreQueries({ accessToken }) {
  const { showLoader, hideLoader } = useUtil();

  const [activeListings, setActiveListings] = useState(0);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState({
    ratings_or_reviews: "4.5/5 based on 20 reviews",
    reviews_count: 20,
  });
  const [details, setDetails] = useState({
    years_of_experience: 10,
    biography:
      "A highly skilled professional with 10 years of experience in the real estate industry, specializing in both residential and commercial properties.",
  });
  const [socialLinks, setSocialLinks] = useState({
    linkedin_link: "https://www.linkedin.com/in/example",
    instagram_link: "https://www.instagram.com/example",
    youtube_link: "https://www.youtube.com/channel/example",
    tiktok_link: "https://www.tiktok.com/@example",
  });


  const handleSubmit = async (event) => {
      event.preventDefault();
      
      try {
        showLoader(); 
  
        // Always update professional details, even if they were previously null
        // console.log("Saving professional details:", professionalDetails);
        
        // Ensure all fields have values, even if empty strings
        const professionalPayload = {
          specialization: professionalDetails.specialization || "",
          years_of_experience: professionalDetails.years_of_experience || "",
          languages: professionalDetails.languages || "",
          linkedin_link: professionalDetails.linkedin_link || "",
          instagram_link: professionalDetails.instagram_link || "",
          youtube_link: professionalDetails.youtube_link || "",
          realtor_license_number: professionalDetails.realtor_license_number || "",
          broker_license_number: professionalDetails.broker_license_number || ""
        };
  
          const professionalResponse = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/professional/details/save`,
            professionalPayload,
            {
              headers: {
                Authorization: accessToken,
              },
            }
          );
          if (
            professionalResponse.status === 200 &&
            professionalResponse.data.success
          ) {
            // Show success toast
            toast.success("Professional details updated successfully!");
          }
        } catch (error) {
          toast.error("Error saving details: " + error.message);
        } finally {
          hideLoader();
        }
    };

  // Add state for the specialization dialog
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };


  const professionalId = 1; // Assuming logged-in professional's ID is 1


  const [formState, setFormState] = useState({
      // userId: "",
      // password: "",
      firstName: "",
      middleName: "",
      lastName: "",
      screenName: "",
      // photo: null,
      email: "",
      phoneNumber: "",
      dateOfBirth: "",
      gender: "",
      country: "",
      bio: "",
    });
    const [professionalDetails, setProfessionalDetails] = useState(null); // State for professional details
  
    // Static list of popular languages
    const languages = [
      "English", "Spanish", "French", "German", "Italian", 
      "Portuguese", "Russian", "Chinese", "Japanese", "Korean",
      "Arabic", "Hindi", "Bengali", "Dutch", "Greek",
      "Turkish", "Vietnamese", "Thai", "Indonesian", "Malay"
    ];
    
    const specializations = [
      "Residential",
      "Commercial",
      "Investment",
      "Specialty Properties",
      "Real Estate Development",
      "Real Estate Management",
      "Distressed Properties",
      "Real Estate Law and Consulting",
      "Green and Sustainable Real Estate",
      "International",
    ];

  const handleProfessionalChange = (e) => {
    const { name, value } = e.target;
    // console.log(`Professional change: ${name} = `, value);
    
    if (name === "specialization") {
      // Convert array to comma-separated string
      const specializationString = Array.isArray(value)
        ? value.join(", ")
        : value;
      // console.log("Specialization string:", specializationString);
      
      setProfessionalDetails((prev) => {
        const updated = {
          ...prev,
          [name]: specializationString,
        };
        // console.log("Updated professional details:", updated);
        return updated;
      });
    } else if (name === "languages") {
      // Convert array to comma-separated string
      const languageString = Array.isArray(value) ? value.join(", ") : value;
      // console.log("Language string:", languageString);
      
      setProfessionalDetails((prev) => {
        const updated = {
          ...prev,
          [name]: languageString,
        };
        // console.log("Updated professional details:", updated);
        return updated;
      });
    } else {
      setProfessionalDetails((prev) => {
        const updated = {
          ...prev,
          [name]: value,
        };
        console.log("Updated professional details:", updated);
        return updated;
      });
    }
  };

  // Fetch Active Listings
  useEffect(() => {
    const fetchActiveListingsCount = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${
            import.meta.env.VITE_BACKEND_URL
          }/dash/dashboard-insights/active-listings`,
          {
            headers: {
              Authorization: accessToken,
            },
          }
        );

        if (response.status === 200 && response.data.success) {
          setActiveListings(response.data.activeCount);
        } else {
          toast.error("Failed to fetch active listings count.");
        }
      } catch (err) {
        toast.error("An error occurred while fetching the data.");
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) {
      fetchActiveListingsCount();
    }
  }, [accessToken]);

  // // Fetch Reviews and Ratings
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/reviews`)
  //     .then((response) => setReviews(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  // // Fetch Years of Experience and Biography
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/details`)
  //     .then((response) => setDetails(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  // // Fetch Social Media Links
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/social-links`)
  //     .then((response) => setSocialLinks(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  // // Fetch Agency Info
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/agency`)
  //     .then((response) => setAgencyInfo(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  // // Fetch Listings
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/listings`)
  //     .then((response) => setListings(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  // // Fetch New Inquiries
  // useEffect(() => {
  //   axios
  //     .get(`/dashboard/professional/${professionalId}/inquiries`)
  //     .then((response) => setNewInquiries(response.data))
  //     .catch((error) => console.error(error));
  // }, [professionalId]);

  useEffect(() => {
    // query to fetch additional professional information
    const fetchAdditionalProInformation = async (accessToken) => {
      try {
        showLoader();
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/dash/pro-information`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (response.status === 200 && response.data && response.data.success) {
          if (
            response.status === 200 &&
            response.data &&
            response.data.success
          ) {
            // Extract and set the professional details
            const { pro } = response.data;
            if (pro) {
              setDetails({
                years_of_experience: pro.years_of_experience || 0,
                biography:
                  pro.biography || "Biography information not available.",
              });
              setSocialLinks({
                linkedin_link: pro.linkedin_link || "",
                instagram_link: pro.instagram_link || "",
                youtube_link: pro.youtube_link || "",
                tiktok_link: pro.tiktok_link || "",
              });
               setProfessionalDetails(pro);
            }
          }
        }
      } catch (error) {
        toast.error("Error while fetching the additional information");
      } finally {
        hideLoader();
      }
    };

    if (accessToken) {
      fetchAdditionalProInformation(accessToken);
    }

    return () => {};
  }, [accessToken]);

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>Professional Dashboard</h1>

      <div className={styles.section}>
        <h2>Active Listings</h2>
        <p>{activeListings}</p>
      </div>

      {/* {reviews && (
        <div className={styles.section}>
          <h2>Reviews</h2>
          <p>{reviews.ratings_or_reviews}</p>
          <p>Total Reviews: {reviews.reviews_count}</p> 
        </div>
      )} */}

      {/* {details && (
        <div className={styles.section}>
          <h2>Profile Details</h2>
          <p>Years of Experience: {details.years_of_experience}</p>
          <p>Biography: {details.biography}</p>
        </div>
      )} */}

      {/* {socialLinks && (
        <div className={`${styles.section} ${styles.socialLink}`}>
          <h2>Social Media Profile Links</h2>
          <p>
            LinkedIn:{" "}
            <a href={socialLinks.linkedin_link} target="_blank">
              LinkedIn
            </a>
          </p>
          <p>
            Instagram:{" "}
            <a
              href={socialLinks.instagram_link}
              className="instagram"
              target="_blank"
            >
              Instagram
            </a>
          </p>
          <p>
            YouTube:{" "}
            <a
              href={socialLinks.youtube_link}
              className="youtube"
              target="_blank"
            >
              YouTube
            </a>
          </p>
          <p>
            TikTok:{" "}
            <a
              href={socialLinks.tiktok_link}
              className="tiktok"
              target="_blank"
            >
              TikTok
            </a>
          </p>
        </div>
      )} */}

    {professionalDetails && (
          <div className={`${styles.section} ${styles.professionalSection}`}>
          <Typography variant="h6" gutterBottom>
            Professional Details
          </Typography>
          <div className={styles.formComponent}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <FormControl fullWidth>
                <InputLabel id="specialization-label">Specialization</InputLabel>
                <Select
                  labelId="specialization-label"
                  id="specialization"
                  name="specialization"
                  multiple
                  value={professionalDetails.specialization
                    ? professionalDetails.specialization.split(", ").filter(Boolean)
                    : []}
                  onChange={handleProfessionalChange}
                  renderValue={(selected) => (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </div>
                  )}
                >
                  {specializations.map((spec) => (
                    <MenuItem key={spec} value={spec}>
                      {spec}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="text"
                onClick={handleClickOpen}
                className={styles.textButton}
                style={{ alignSelf: 'flex-start' }}
              >
                Detailed specialization information
              </Button>
            </div>
          </div>
          <div className={`${styles.formComponent} ${styles.componentType1}`}>
            <TextField
              label="Years of Experience"
              value={professionalDetails.years_of_experience || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  years_of_experience: e.target.value,
                }))
              }
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel id="languages-label">Languages</InputLabel>
              <Select
                id="languages"
                name="languages"
                label="Languages"
                variant="outlined"
                multiple
                value={professionalDetails.languages
                  ? professionalDetails.languages.split(", ").filter(Boolean)
                  : []}
                onChange={handleProfessionalChange}
                renderValue={(selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </div>
                )}
              >
                {languages.map((language) => (
                  <MenuItem key={language} value={language}>
                    {language}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={styles.formComponent}>
            <TextField
              label="LinkedIn"
              value={professionalDetails.linkedin_link || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  linkedin_link: e.target.value,
                }))
              }
              fullWidth
            />
          </div>
          <div className={styles.formComponent}>
            <TextField
              label="Instagram"
              value={professionalDetails.instagram_link || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  instagram_link: e.target.value,
                }))
              }
              fullWidth
            />
            
          </div>
          <div className={styles.formComponent}>
            <TextField
              label="YouTube"
              value={professionalDetails.youtube_link || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  youtube_link: e.target.value,
                }))
              }
              fullWidth
            />
          </div>
          {/* <div className={styles.formComponent}>
            <TextField
              label="Realtor License Number"
              value={professionalDetails.realtor_license_number || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  realtor_license_number: e.target.value,
                }))
              }
              fullWidth
            />
          </div>

          <div className={styles.formComponent}>
            <TextField
              label="Broker License Number"
              value={professionalDetails.broker_license_number || ""}
              onChange={(e) =>
                setProfessionalDetails((prev) => ({
                  ...prev,
                  broker_license_number: e.target.value,
                }))
              }
              fullWidth
            />
          </div> */}

          <div className={styles.formComponent}>
            <div className={styles.formAction}>
              <Button variant="contained" size="large" onClick={handleSubmit}>
                Save Details
              </Button>
            </div>
          </div>

          {/* Add the specialization dialog */}
                <Dialog open={open} onClose={handleClose}>
                  <DialogTitle>
                    {"Detailed specialization information"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <ul>
                        <li>
                          <strong>Residential Real Estate</strong>
                          <ul>
                            <li>
                              Single-Family Homes: Specializing in the buying and
                              selling of individual family homes.
                            </li>
                            <li>
                              Luxury Properties: Focusing on high-end, luxury
                              residential properties.
                            </li>
                            <li>
                              Condominiums and Townhouses: Specializing in condo
                              and townhouse sales.
                            </li>
                            <li>
                              First-Time Homebuyers: Assisting clients who are
                              purchasing their first home.
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Commercial Real Estate</strong>
                          <ul>
                            <li>
                              Office Buildings: Specializing in the sale, leasing,
                              or management of office spaces.
                            </li>
                            <li>
                              Retail Properties: Focusing on shopping centers,
                              malls, and standalone retail spaces.
                            </li>
                            <li>
                              Industrial Real Estate: Specializing in warehouses,
                              manufacturing facilities, and other industrial
                              properties.
                            </li>
                            <li>
                              Multi-Family Housing: Specializing in apartment
                              complexes and other multi-unit residential properties.
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Investment Properties</strong>
                          <ul>
                            <li>
                              Rental Properties: Specializing in properties for
                              rental income.
                            </li>
                            <li>
                              Fix and Flip: Focusing on properties that can be
                              renovated and resold for profit.
                            </li>
                            <li>
                              Real Estate Investment Trusts (REITs): Specializing
                              in REIT investments.
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Specialty Properties</strong>
                          <ul>
                            <li>
                              Agricultural Land: Specializing in farms, ranches,
                              and other agricultural properties.
                            </li>
                            <li>
                              Vacation Homes: Focusing on properties for vacation
                              or second-home use.
                            </li>
                            <li>
                              Historic Properties: Specializing in historic homes
                              and buildings.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                  </DialogActions>
                </Dialog>
        </div>       
      )} 

    </div>
  );
}

export default ProMoreQueries;
